import Image from "next/image";
import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Button,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { FiChevronRight, FiX } from "react-icons/fi";
import { Text } from "../../../../atoms";
import { useScreenSize } from "../../../../hooks/useScreenSize";
import { SlClose } from "react-icons/sl";

export const SizeChartDialog = ({ url }: { url: string }) => {
  const [show, setShow] = useState(false);
  const { isMobile } = useScreenSize();
  const onClose = () => {
    setShow(false);
  };
  return (
    <>
      <Button
        onClick={() => setShow(true)}
        size="small"
        color="secondary"
        endIcon={<FiChevronRight />}>
        Size Chart
      </Button>
      <Dialog
        open={show}
        onClose={onClose}
        fullScreen={isMobile}
        fullWidth
        disablePortal>
        <DialogTitle>
          <div className="flex justify-between">
            <p className="sectionTitle text-lg">Size chart</p>
            <IconButton onClick={onClose}>
              <SlClose />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="w-full h-[500px] relative">
            <img
              src={url}
              alt="Image"
              className="w-full h-full object-contain"
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
